var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0221 9.95371C11.8242 9.95371 10.0369 8.16802 10.0369 5.97223C10.0369 3.77644 11.8242 1.99074 14.0221 1.99074C16.22 1.99074 18.0074 3.77644 18.0074 5.97223C18.0074 8.16802 16.22 9.95371 14.0221 9.95371ZM14.0221 0C10.7203 0 8.04424 2.67357 8.04424 5.97223C8.04424 7.26621 8.4607 8.46165 9.1611 9.4401L0 18.5925L1.40879 20L2.82953 18.5806L4.21042 19.9602L5.6202 18.5527L4.23832 17.1731L6.21002 15.2033L7.61084 16.6028L9.01963 15.1953L7.61881 13.7958L10.5729 10.8446C11.5483 11.5354 12.7359 11.9445 14.0221 11.9445C17.3239 11.9445 20 9.27089 20 5.97223C20 2.67357 17.3239 0 14.0221 0Z",
    fill: "#3B414D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.d369008f690f23c973696c2ba76f7336.svg";
export { ForwardRef as ReactComponent };